<script>
    import { displayDate } from "../../utils/utils";
    import Requirement from "../ui/Requirement.svelte";
    export let min;
    export let max;
    export let inBoundaries;
    export let available;
</script>

<div>
    {#if min && max}
        <Requirement condition={inBoundaries}>
            Datum muss zwischen dem {displayDate(min)} und dem {displayDate(max)} liegen
        </Requirement>
    {:else if max}
        <Requirement condition={inBoundaries}>
            Datum muss vor dem {displayDate(max)} liegen
        </Requirement>
    {:else if min}
        <Requirement condition={inBoundaries}>
            Datum muss nach dem {displayDate(min)} liegen
        </Requirement>
    {/if}
    <!-- <Requirement condition={available}>
        Datum darf nicht an einem belegten Tag sein
    </Requirement> -->
</div>

<style>
    div {
        margin: 1rem 0 0;
    }
</style>